import LogUtil from '@/core/utils/logUtil';
import {gsap} from 'gsap';
import RegionalComparisonModel from '../model/regionalComparisonModel';

export default class StepController {

    private static _timeline:any = null;
    private static steps:any = null;
    private static target:any = null;
    private static current_step:any = null;
    private static previous_step:any = null;

    static setTimeline(onComplete:any = null) {
        StepController._timeline = gsap.timeline({paused: false, onComplete: onComplete});
    }

    static setSteps(steps) {

        // adding a mock step to use once initially (args index need to be position of callback "next")
        StepController.previous_step = {_id: '', hide() {arguments[2]()}};
        StepController.steps = steps;
    }

    static setTarget(target) {

        StepController.target = target;
    }

    static nextStep(stepName) {

        let next = () => {

            LogUtil.logClass(StepController, 'Next step in view:', stepName);
            RegionalComparisonModel.stepContext = stepName;

            StepController.current_step = StepController.steps[stepName];
            StepController.current_step.appendTo(StepController.target);
            StepController.current_step.init();

            StepController.current_step.show(StepController._getTimeline(), StepController.previous_step._id);

            StepController.previous_step = StepController.current_step;
        };

        StepController.previous_step.hide(StepController._getTimeline(), stepName, next);
    }

    static _getTimeline() {

        return StepController._timeline;
    }

    static reset() {

        StepController.current_step = null;
        StepController.previous_step = null;
        StepController.target = null;
        StepController.steps = null;
        StepController._timeline = null;
    }
}
